import React from 'react';

export const EvolveIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_29_1186)'>
      <path
        d='M28 13.8497C27.9599 10.1618 26.5179 6.71439 23.8941 4.08876C21.2504 1.46314 17.7454 0 14 0C10.2546 0 6.74964 1.46314 4.10587 4.1088C1.46209 6.73443 0 10.262 0 13.99C0 17.738 1.46209 21.2455 4.10587 23.8912C6.68956 26.4767 10.0944 27.9198 13.7396 27.98H14C17.7454 27.98 21.2504 26.5168 23.8941 23.8712L24.3748 23.3901L22.2318 21.2656L21.7511 21.7466C19.6881 23.811 16.9242 24.9535 14 24.9535C11.0758 24.9535 8.3319 23.811 6.24893 21.7466C4.18598 19.6822 3.04435 16.9363 3.04435 14.01C3.04435 11.0838 4.18598 8.33787 6.24893 6.27344C8.31187 4.20902 11.0758 3.06657 14 3.06657C16.9242 3.06657 19.6681 4.20902 21.7511 6.27344C23.4535 7.97709 24.535 10.1417 24.8555 12.5068H22.7124H22.5722C22.2718 10.7631 21.4306 9.15963 20.1688 7.87688C18.5064 6.21331 16.3233 5.31138 14 5.31138C11.6767 5.31138 9.49356 6.21331 7.85122 7.85684C6.20887 9.50036 5.30758 11.685 5.30758 13.99C5.30758 16.315 6.20887 18.4996 7.85122 20.1432C9.45351 21.7466 11.5765 22.6485 13.8598 22.6886H14.02C16.3433 22.6886 18.5265 21.7867 20.1688 20.1432L20.6495 19.6621L18.4664 17.5175L17.9857 17.9986C16.9242 19.0608 15.5021 19.6621 13.98 19.6621C12.4578 19.6621 11.0558 19.0809 9.97425 17.9986C9.27325 17.2971 8.79256 16.4553 8.53219 15.5132H12.4578H13.98H19.628H22.6724H27.98L28 13.8497ZM14 12.4868H12.4778H8.55222C8.81259 11.5648 9.29328 10.7029 9.99428 10.0014C11.0558 8.93916 12.4778 8.33787 14 8.33787C15.5222 8.33787 16.9242 8.91911 18.0057 10.0014C18.7067 10.7029 19.1874 11.5447 19.4478 12.4868H14Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_29_1186'>
        <rect width='28' height='28' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
